import { get } from './common';
const baseCountryApiPrefix = '/WebApi/api/country';
export const getCountries = async () => {
    const result = await get(`${baseCountryApiPrefix}`);
    if (!result.ok) {
        throw new Error(`Failed to get countries: ${result.statusText}`);
    }
    return result.json();
};
